<template>
<div class="dashboard" v-if="dashboard.dataUser">

<b-container class="bv-example-row">
  <b-row class="top-page" align-h="between" >
    <b-col cols="12" md="6">
    <p class="header">DashBoard</p>
    <p class="sub-header">Olá, {{dashboard.dataUser.first_name}}!</p>
    </b-col>
   
    <b-col cols="12" md="6" class="text-right">
    <p class="earnings">R$ 5.000,00</p>
    <p class="earnings-text"><i class="fas fa-wallet"></i> Receita do Mês  </p>
    </b-col>
  </b-row>
</b-container>

<b-container class="cards">
   
<b-row>
        <b-col cols="6" md="3"><boxComponent class="card-item" :numero="0" cor="" titulo="orçamentos" url="#" icone="fa-concierge-bell"/></b-col>
        <b-col cols="6" md="3"><router-link :to="{name: 'products'}"><boxComponent class="card-item" :numero="dashboard.products" cor="" titulo="Produtos" url="#" icone=" fa-shopping-cart"/></router-link></b-col>
        <b-col cols="6" md="3"><router-link :to="{name: 'clients'}"><boxComponent class="card-item" :numero="dashboard.clients" cor="" titulo="Clientes" url="#" icone=" fa-users"/></router-link></b-col>
        <b-col cols="6" md="3"><boxComponent class="card-item" :numero="0" cor="" titulo="Finalizados" url="#" icone="fa-bolt"/></b-col>
</b-row>
</b-container>


<b-container class="cards">
  <b-row>
    <b-col md="8">
        <b-card border-variant="white">
            <b-card-body title="Orçamentos Recentes" class="table-responsive">
             <b-skeleton-table v-if="!dashboard.recent_products"
                        animation="wave"
                        :rows="5"
                        :columns="6"
                        :table-props="{ bordered: false, striped: false }"
                ></b-skeleton-table>

                <div v-else class="table">
                <table>
                <thead>
                <tr>
                <th>Produto</th>
                <th>V. Compra</th>
                <th>Lucro</th>
                <th>V. Venda</th>
                </tr>
                </thead>
                <tbody v-if="dashboard.recent_products.lenght > 0">
                    <tr  v-for="(product, index) in dashboard.recent_products" :key="index">
                    <td>{{product.description_products}}</td>
                    <td>{{product.buy_price_products}}</td>
                    <td>{{product.earning_products}}</td>
                    <td>{{product.sell_price_products}}</td>
                    </tr>  
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="5" class="text-center">
                     Não a registros a serem mostrados
                    </td>
                </tr>             
                </tbody>
                </table>
                </div>

                <b-button v-if="dashboard.recent_products.lenght > 0" :to="{name: 'products'}">Ver Mais</b-button>
            </b-card-body>
        </b-card>

    </b-col>
    <b-col md='4'>
                <b-card border-variant="white">
            <b-card-body no-body title="Calendário" >
                <b-calendar
                        border-variant="white"
                        v-model="value"
                        block locale="pt-BR"
                        :start-weekday="weekday"
                        :hide-header="hideHeader"
                        :show-decade-nav="showDecadeNav"
                        @context="onContext"
                ></b-calendar>
            </b-card-body>
        </b-card>
    </b-col>
  </b-row>

    </b-container>
</div>
</template>

<script>
    import boxComponent from "../../boxComponent";


    export default {
        name: "dashboardComponent",
        components: {
            
            boxComponent
        },
        data() {
            return{
                value: '',
                products: false,
                context: null,
                showDecadeNav: false,
                hideHeader: true,
                locale: 'pt-BR',
                weekday: 0,

            }
        },


        methods: {

                onContext(ctx) {
                this.context = ctx
            }
        },
        computed: {
                  dashboard(){
                return this.$store.getters.dashboard
            }
        },

        created() {
        this.$store.dispatch('getDashboard')
        this.$store.dispatch('getProducts')  
        },
    }
</script>

<style lang="scss" scoped>


    .cards{
        padding-left: 0px;
        padding-right: 0px;
        padding-top: 35px;

        .card-item {
    border-radius: 5px !important;
}
    }

    @media (max-width: 768px) {

    .top-page{

color: #333;

      .header{
          text-align: center;
      }  
      .sub-header{
          text-align: center;
          line-height: 5px;
      }

      .earnings{
          font-size: 30px !important;
          font-weight: lighter;
          text-align: center;
          padding-top: 25px;
           line-height: 25px;

      }
      .earnings-text{
          font-size: 19px !important;
          font-weight: lighter;
           text-align: center;

          
    line-height: 5px;

      }
    }
    }


    .top-page{

color: #333;

      .header{
          font-size:40px;
      }  
      .sub-header{
          font-size: 25px;
          font-weight: lighter;
          text-transform: capitalize;
          
    line-height: 5px;

      }

      .earnings{
          font-size: 35px;
          font-weight: lighter;
      }
      .earnings-text{
          font-size: 23px;
          font-weight: lighter;

          
    line-height: 5px;

      }
    }

</style>